import { Box } from '@mui/material';
import BaseTypography from 'components/typography/BaseTypography';
import { reusableStyles } from 'ui-blocks/ReusableStyles';
import { ReactComponent as YCombinatorLogo } from 'assets/svg/y-combinator.svg';
import React from 'react';

export default function TrustedSection() {
	return (
		<Box
			id="trusted-section"
			sx={[
				reusableStyles.flexColWithGap(30),
				reusableStyles.flexCenter,
				{
					paddingY: '47px',
					borderRadius: '32px',
					backgroundColor: 'colors.dark45',
					width: '100%',
				},
			]}
		>
			<BaseTypography variant="h2_zodiak" styles={{ color: 'colors.light3', textAlign: 'center' }}>
				Trusted by 1.5Mn creators, marketers, agencies and brands
			</BaseTypography>
			<Box sx={[reusableStyles.flexRowWithGap(16)]}>
				<BaseTypography
					variant="t1_regular"
					styles={{ color: 'colors.light4', textAlign: 'center' }}
				>
					Backed by
				</BaseTypography>
				<YCombinatorLogo />
			</Box>
		</Box>
	);
}
